<template>
  <router-view />
</template>

<script>
  import { initPubSub } from '@u/pubSub'
  import { useCommonStore } from '@s/common'
  import { getDeviceInfo } from '@u/native'

  export default {
    created() {
      initPubSub()
    },
    setup() {
      const commonStore = useCommonStore()
      const deviceInfo = getDeviceInfo()
      commonStore.setDeviceInfo(deviceInfo)
    },
  }
</script>
